import React from 'react';
import { TranDetailContainer } from '../../../containers';

export const TranDetail = () => <TranDetailContainer />;
